<template>
    <div>
        <form class="form-horizontal" >

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-3">
                            <label for="numero" :class="{'text-danger': !splitter.potencia}" class="control-label">POTÊNCIA DO SPLITTER</label>
                            <input id="numero" type="text" v-model="splitter.potencia" class="form-control" >
                        </div>

                        <div class="col-sm-3">
                            <label for="nome" class="control-label">NOME DO SPLITTER</label>
                            <input id="nome" disabled type="text" :value="(splitter.potencia) ? 'SPL-' + splitter.potencia : ''" class="form-control" >
                        </div>

                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5" :disabled="! splitter.potencia"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR SPLITTER
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import { Splitter } from "../../../class/index";

export default {
    data() {
        return {
            user: null,
            splitter: Splitter.create(),
            fibra: null
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        }
    },
    methods: {
        async loadPonto() {
            this.splitter = await Splitter.byID(this._id);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o splitter?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Splitter.save(this.splitter)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/splitters" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
